export default "__VITE_ASSET__BKzYYTdC__"